import { BookingQualificationRequirements } from "@justhome/api-core";
import { GuardArgs } from "xstate/guards";
import { QualificationContext, QualificationEvent } from "./machine";

type Args = GuardArgs<QualificationContext, QualificationEvent>;

export const needsLeadWall = ({ context }: Args) => !context.leadId;

export const needsEquity = (
  requirements: BookingQualificationRequirements | undefined,
) => !!requirements?.equity;

export const needsResidence = (
  requirements: BookingQualificationRequirements | undefined,
) => !!(requirements?.residencePermit || requirements?.nationality);

export const needsEmployment = (
  requirements: BookingQualificationRequirements | undefined,
) => !!requirements?.employmentType;

export const needsIncome = (
  requirements: BookingQualificationRequirements | undefined,
) => !!requirements?.income;

export const needsPropertyViewingStatus = (
  requirements: BookingQualificationRequirements | undefined,
) => !!requirements?.propertyViewingStatus;

export const isDisqualified = ({ context }: Args) => !!context.isDisqualified;

export const isDisqualifiedFromOutput = ({ event }: any) =>
  event.output?.isDisqualified ?? false;

export const isFromPartner = ({ context }: Args) => !!context.partnerId;

export const needsReconfirmation = ({ context }: Args) =>
  !!context.needsReconfirmation;

export const needsProperty = (
  requirements: BookingQualificationRequirements | undefined,
) => !!(requirements?.purchasePrice && requirements?.postalCode);

export const hasPastMeetings = (
  requirements: BookingQualificationRequirements | undefined,
) => !!requirements?.hasPastMeetings;

export const hasUnconfirmedMatchedProject = ({ context }: Args) =>
  !!(context.dealId && context.matchedProject && !context.projectDecisionMade);

export const createGuard =
  (
    fn: (requirements: BookingQualificationRequirements | undefined) => boolean,
  ) =>
  ({ context }: Args) =>
    fn(context.requirements);

export const isSkipQualification = ({ context }: Args) =>
  !!(context.skipQualification && context.leadId);
